import React, {useState } from 'react';
import { useParams } from 'react-router-dom';
import ColumnView from '../../components/ColumnView';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';
import useGetColumnDetail from '../../hooks/useGetColumnDetail';

type Params = {
    strContentSeq: string;
}

const ColumnDetail: React.FC = () => {
    const {strContentSeq} = useParams<Params>();
    const [contentSeq] = useState<number>(strContentSeq? parseInt(strContentSeq) : 0);
    const {data, isLoading} = useGetColumnDetail(contentSeq);
    const handleGoList = () => {
        window.location.href = "/column/columnList";
    }
    const handleGoDetail = (contentSeq: number | undefined) => {
        window.location.href = `/column/columnDetail/${contentSeq}`;
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>전문심리칼럼</h2>
                        <Location locations={[{title: "토닥토닥마음케어", url: "/columnList"}]} menuName='전문심리칼럼' />
                        {
                            isLoading && !data ? (
                                <div>Loading....</div>
                            ) : (
                                <ColumnView 
                                    title={data?.data.title}
                                    content={data?.data.content}
                                    prevContentSeq={data?.data.prevContentSeq} 
                                    prevTitle={data?.data.prevTitle}
                                    nextContentSeq={data?.data.nextContentSeq}
                                    nextTitle={data?.data.nextTitle}
                                    handleGoList={handleGoList} 
                                    handleGoDetail={handleGoDetail} />
                            )
                        }
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default ColumnDetail;